module.exports = __webpack_public_path__ + "static/media/CICLO_5_PROSPERIDAD_DIGITAL_2022.26441252.jpg";